import {
  authToken,
  authRefToken,
  getUser,
  getListDepartment,
  getOwnerMenu
} from '../../api/usermanage'
import {
  getLocalCity
} from '../../api/common'
import {
  getToken,
  setToken,
  removeToken,
  signOut
} from '../../utils/auth'
import {
  formatTreeData,
  getRootDomain,
  uuid
} from '../../utils/utils'

const readModle = window.localStorage.getItem('FnArticleReadModle')

const user = {
  state: {
    localCity: {

    },
    domain: null,
    user: {},
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    resourceCode: [],
    setting: {
      articlePlatform: []
    },
    readModle: readModle ? JSON.parse(readModle) : {
      viewType: 0, // 0：原始浏览， 1：纯净浏览
      tsType: 0, // 0：简体， 1：繁体
      fontSize: 12
    },
    gloadConfig: {},
    menuConfig: {},
    noAsyncGetToken: false
  },

  mutations: {
    SET_NOASYNCGETTOKEN: (state, noSyncGetToken) => {
      state.noAsyncGetToken = noSyncGetToken
    },
    SET_REDMODLE: (state, readModle) => {
      state.readModle = readModle
    },
    SET_RESOURCECODE: (state, codes) => {
      state.resourceCode = codes
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_DOMAIN: (state, domain) => {
      state.domain = domain
    },
    SET_LOCALCITY: (state, localCity) => {
      state.localCity = localCity
      window.localStorage.setItem('GET_LOCALCITY', JSON.stringify(localCity))
    }
  },

  actions: {
    setToken({ commit }, data) {
      let time = new Date().getTime()
      return new Promise((resolve, reject) => {
        let { expires_in = 0, access_token, refresh_token } = data
        // let accesstoken = res.access_token
        let domain = getRootDomain()
        commit('SET_TOKEN', access_token)
        commit('SET_REFTOKEN', refresh_token)
        commit('SET_DOMAIN', domain)
        setToken(access_token, { domain: domain, expires: new Date(time + (expires_in * 1000)) })
        setToken(refresh_token, { domain: domain }, 'FN_REFTOKEN')
        resolve(access_token)
      })
    },
    getLocalCity({ commit, state }) {
      let localCity = window.localStorage.getItem('GET_LOCALCITY')
      return new Promise((resolve, reject) => {
        if (localCity) {
          resolve(JSON.parse(localCity))
          return
        }
        getLocalCity().then(res => {
          commit('SET_LOCALCITY', res)
          resolve(res)
        })
      })
    },
    RefreshToken({ commit, dispatch }) {
      let data = {
        grant_type: 'refresh_token',
        rdKey: uuid(),
        refresh_token: getToken('FN_REFTOKEN')
      }
      return new Promise((resolve, reject) => {
        authToken(data).then(res => {
          dispatch('setToken', res).then(token => {
            resolve(token)
          })
        }).catch((err) => {
          dispatch('LogOut').then(() => {
            reject(err)
          })
        })
      })
    },
    // 用户名登录
    LoginByUsername({ commit, dispatch }, userInfo) {
      // const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        authToken(userInfo).then(res => {
          dispatch('setToken', res).then(data => {
            resolve()
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetOwnerMenu({ commit }) {
      return new Promise((resolve, reject) => {
        getOwnerMenu().then(res => {
          if (res.data && res.data.length) {
            commit('SET_ROLES', res.data)
            resolve(res.data)
          } else {

            reject(new Error('未获取到用户菜单'))
          }
          // commit('SET_ROLES', res.data)
          // resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        getUser(state.token).then(res => {
          let projectConfig = res.data.projectConfig || {}
          let { customJson = {} } = res.data.personConfig || {}

          dispatch('SetGlobaConfig', { ...projectConfig, customJson })
          dispatch('GetOwnerMenu').then(data => {
            commit('SET_RESOURCECODE', res.data.resourceCode)
            commit('SET_NAME', res.data.user.userName)
            commit('SET_USER', res.data.user)
            resolve(formatTreeData(data))

          }).catch(error => {

            reject(error)
          })
          // resolve(res)
        }).catch(error => {

          reject(error)
        })
      })
    },

    GetDepartment({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        getListDepartment(data).then(res => {
          let arrTree = formatTreeData(res.data, 'departID', 'fatherID')
          resolve(arrTree)
        }).catch(err => {
          reject(new Error(err))
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        // let domain = getRootDomain()
        let domain = getRootDomain()
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken({ domain: domain })
        removeToken({ domain: domain }, 'FN_REFTOKEN')
        resolve()
      })
        .then(success => {
          signOut()
        }, err => console.log(err))
    },
    // // 获取历史阅读模式
    // getRedModle({ state, commit }) {
    //   return new Promise(resolve => {
    //     if (state.readModle) {

    //     } else {
    //       window.localStorage.setItem('FnArticleReadModle', JSON.stringify(readModle))
    //     }
    //     resolve()
    //   })
    // },
    // 获取阅读模式
    setRedModle({ commit }, readModle) {
      return new Promise(resolve => {
        window.localStorage.setItem('FnArticleReadModle', JSON.stringify(readModle))
        commit('SET_REDMODLE', readModle)
        resolve()
      })
    }

    // 前端 登出
    // FedLogOut({ commit, state }) {
    //   return new Promise(resolve => {
    //     // let domain = getRootDomain()
    //     commit('SET_TOKEN', '')
    //     removeToken({ domain: state.domain })
    //     resolve()
    //   })
    // }
  }
}

export default user
